import { Component, computed, inject, signal, OnInit } from "@angular/core";
import { AnalyticsService } from "@services/analytics.service";
import { DeviceCapabilityService } from "@services/device-capability.service";

@Component({
  selector: "app-fullscreen-button",
  template: `
    @let shouldShowFullScreenButton = deviceCapabilityService.hasFullScreenCapabilities();

    @if (shouldShowFullScreenButton) {
      <button class="btn-icon btn-secondary" (click)="toggleFullscreen()">
        <img [src]="iconSrc()" [alt]="altDescription()" />
      </button>
    } @else {
      <div class="placeholder"></div>
    }
  `,
  standalone: true,
  host: {
    "(document:fullscreenchange)": "onFullscreenChange()",
    "(document:webkitfullscreenchange)": "onFullscreenChange()",
    "(document:mozfullscreenchange)": "onFullscreenChange()",
    "(document:MSFullscreenChange)": "onFullscreenChange()",
  },
  styles: `
    .placeholder {
      width: 56px;
      height: 56px;
      opacity: 0;
    }
  `,
})
export class FullScreenButton implements OnInit {
  private analyticsService = inject(AnalyticsService);
  protected deviceCapabilityService = inject(DeviceCapabilityService);

  protected iconSrc = computed<string>(() => `assets/icons/${this.isFullScreen() ? "exit" : "open"}-fullscreen.svg`);
  protected altDescription = computed<string>(() => `${this.isFullScreen() ? "close" : "open"} fullscreen view`);
  protected isFullScreen = signal<boolean>(false);

  ngOnInit() {
    this.deviceCapabilityService.hasFullScreenCapabilities();
  }

  async toggleFullscreen() {
    const rootElement = document.documentElement;

    if (document.fullscreenElement) {
      this.analyticsService.trackFullScreenOff();

      try {
        await document.exitFullscreen();
        // eslint-disable-next-line
      } catch (err: any) {
        if (err instanceof Error) {
          this.analyticsService.trackException(err);
        }
      }
    } else {
      this.analyticsService.trackFullScreenOn();

      try {
        await rootElement.requestFullscreen();
        // eslint-disable-next-line
      } catch (err: any) {
        if (err instanceof Error) {
          this.analyticsService.trackException(err);
        }
      }
    }
  }

  onFullscreenChange() {
    this.isFullScreen.update(previousValue => !previousValue);
  }
}
